import React, { useEffect, useMemo, useState } from "react";
import { SovosTab, SovosTabs } from "mosaic-react";
import { hydrateRoute } from "colbi_web_ui/lib/utils";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
const TABS = [
    { model: "package_rules", labelKey: "rules" },
    { model: "package_kpis", labelKey: "settings_menu_kpis" },
    { model: "package_custom_reports", labelKey: "custom_reports" },
];

const BASE_PATH = "/:locale(pt|en|lt|es|ro|fr)?/settings/:section/packages-association/:id";

const PackageAssociationTabs = () => {
    const { params, location, history, i18n } = useGlobalValue();
    const hydratedBase = hydrateRoute(BASE_PATH, { ...params });
    const [selectedTab, setSelectedTab] = useState("");

    const tabPaths = useMemo(
        () =>
            TABS.map(({ model }) => {
                const path = `${hydratedBase}${hydratedBase.endsWith("/") ? "" : "/"}${model}`;
                return location.search ? `${path}${location.search}` : path;
            }),
        [hydratedBase, location.search],
    );

    useEffect(() => {
        const pathname = location.pathname;
        const match = tabPaths.find((path) => path.split("?")[0] === pathname);
        setSelectedTab(match || tabPaths[0] || pathname);
    }, [location.pathname, location.search, tabPaths]);

    return (
        <SovosTabs
            value={selectedTab}
            onChange={(_, value) => {
                setSelectedTab(value);
                history.push(value);
            }}
        >
            {TABS.map(({ model, labelKey }, index) => (
                <SovosTab
                    key={model}
                    value={tabPaths[index]}
                    label={i18n`${labelKey}`}
                />
            ))}
        </SovosTabs>
    );
};

export default PackageAssociationTabs;
